import React from 'react';
import { motion } from 'framer-motion';
import { Check, FileText, LayoutTemplate, ListTodo } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-24 px-6 bg-bg-main" data-id="element-164">
      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-165">
        {/* Left Column: Outcomes */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} data-id="element-166">
          <h2 className="text-3xl md:text-4xl font-serif text-text-primary mb-10" data-id="element-167">
            Lo que vas a lograr en 30 días
          </h2>
          <ul className="space-y-6" data-id="element-168">
            {['Detectar impulsos antes de comprar', 'Enfriar compras con reglas de 24–48h', 'Cortar tus 3 fugas principales (las que te dañan de verdad)', 'Cerrar el mes con plata visible (aunque sea poca)', 'Tener un plan para las “noches peligrosas”', 'Volver al camino sin castigarte si te descarrilas'].map((item, i) => <li key={i} className="flex items-start" data-id="element-169">
                <div className="mt-1 mr-4 w-5 h-5 rounded-full bg-brand-purple/20 flex items-center justify-center flex-shrink-0" data-id="element-170">
                  <Check className="w-3 h-3 text-brand-purple" data-id="element-171" />
                </div>
                <span className="text-lg text-text-primary/90" data-id="element-172">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Right Column: Inclusions */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="bg-bg-card p-8 rounded-3xl border border-white/10 relative overflow-hidden" data-id="element-173">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-[60px] pointer-events-none" data-id="element-174" />

          <h3 className="text-2xl font-serif text-text-primary mb-8 flex items-center" data-id="element-175">
            <span className="bg-brand-gold text-bg-main text-xs font-bold px-2 py-1 rounded mr-3 uppercase tracking-wider" data-id="element-176">
              Incluye
            </span>
            Lo que recibes hoy
          </h3>

          <div className="space-y-8" data-id="element-177">
            <div className="flex gap-4" data-id="element-178">
              <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-179">
                <FileText className="w-6 h-6 text-brand-pink" data-id="element-180" />
              </div>
              <div data-id="element-181">
                <h4 className="text-lg font-medium text-text-primary mb-1" data-id="element-182">
                  PDF Workbook de 30 días
                </h4>
                <p className="text-sm text-text-secondary" data-id="element-183">
                  Paso a paso, día por día. Tu guía de ejecución.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-184">
              <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-185">
                <LayoutTemplate className="w-6 h-6 text-brand-purple" data-id="element-186" />
              </div>
              <div data-id="element-187">
                <h4 className="text-lg font-medium text-text-primary mb-1" data-id="element-188">
                  Plantillas (Sheets/Notion)
                </h4>
                <ul className="text-sm text-text-secondary space-y-1 mt-2 list-disc pl-4" data-id="element-189">
                  <li data-id="element-190">Tracker de impulsos</li>
                  <li data-id="element-191">Presupuesto de supervivencia</li>
                  <li data-id="element-192">Lista blanca / Lista negra</li>
                  <li data-id="element-193">Reparación sin drama</li>
                </ul>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-194">
              <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-195">
                <ListTodo className="w-6 h-6 text-brand-gold" data-id="element-196" />
              </div>
              <div data-id="element-197">
                <h4 className="text-lg font-medium text-text-primary mb-1" data-id="element-198">
                  Checklist Imprimible
                </h4>
                <p className="text-sm text-text-secondary" data-id="element-199">
                  “Cierra el Mes” en 30 minutos.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}